import Program from 'nanogl/program'
import Texture from 'nanogl/texture'

import gui from '@/webgl/dev/gui'
import { Gui } from '@/webgl/dev/gui/api'
import FPSLimiter from '@/webgl/FPSLimiter'
import BaseEffect from '@/webgl/postprocess/effects/base-effect'
import AssetDatabase from '@/webgl/resources/AssetDatabase'

const G_SIZE = 256

export default class Grain extends BaseEffect {
  shaderPre = /*glsl*/ `

  uniform vec4 uGrainCoord;
  uniform vec2 uGrainScaleBias;
  uniform sampler2D tGrain;
 
  `

  shader = /*glsl*/ `
  float grain = texture2D(tGrain, texCoordVP * uGrainCoord.xy).x;
  c += grain * uGrainScaleBias.y;
  `

  amount: number
  size: number
  limit: FPSLimiter

  private _noiseTex: Texture | null

  private _noises: Texture[] = []
  private _tindex: number = 0

  constructor() {
    super()

    this.amount = 0.67
    this.size = 0.35
    // this.size = 0.22;

    this._noiseTex = null

    this.limit = new FPSLimiter()
    this.limit.enabled = true
    this.limit.fps = 6
  }

  //#region GUI
  folder: Gui
  setupGUI(root: Gui) {
    this.folder = root ? root.folder('Grain') : gui.folder('Grain')
    this.folder.add(this, 'amount', { min: 0, max: 4.0 })
    this.folder.add(this, 'size', { min: 0, max: 2.0 })
    this.folder.add(this.limit, 'fps', { min: 0, max: 60 }).setLabel('FPS')
  }
  //#endregion

  genCode(precode: string[], code: string[]) {
    precode.push(this.shaderPre)
    code.push(this.shader)
  }

  init() {}

  async load(): Promise<void> {
    this._noises = [
      await AssetDatabase.getTexture('noise/Light_Texture00.jpg', this.post!.gl).load(),
      await AssetDatabase.getTexture('noise/Light_Texture01.jpg', this.post!.gl).load(),
      await AssetDatabase.getTexture('noise/Light_Texture02.jpg', this.post!.gl).load(),
      await AssetDatabase.getTexture('noise/Light_Texture03.jpg', this.post!.gl).load(),
    ]
  }

  release() {
    if (this._noiseTex !== null) this._noiseTex.dispose()
    this._noiseTex = null
  }

  update(dt: number) {
    if (this.limit.step(dt)) {
      this._tindex = (this._tindex + 1) % this._noises.length
    }
  }

  setupProgram(prg: Program) {
    const ig = 1 / G_SIZE,
      bw = this.post!.bufferWidth,
      bh = this.post!.bufferHeight,
      ms = 1 - this.size

    prg.uGrainCoord(ig * bw * this.size, ig * bh * this.size, 0.5 * ms * ig, 0.5 * ms * ig)

    prg.uGrainScaleBias(2 * this.amount, this.amount)

    prg.tGrain(this._noises[this._tindex])
  }

  preRender(): void {}
  resize(w: number, h: number): void {}
}
